import React from 'react';
import type { BlockDateTime } from 'types/block-date-time';

import Image from 'next/image';
import { Paragraph, Button, Wrap } from '@leafwell/components';

const DateTimes: React.FC<BlockDateTime> = ({ title, subtitle, dateTimes }) => {
  return (
    <Wrap>
      <section className="grid grid-cols-4 lg:gap-y-24 p-6 md:p-10 text-center lg:text-left rounded-xl bg-lilac-50">
        {title ? (
          <Paragraph
            tagName="h2"
            className="col-span-4 lg:col-span-2 mb-8 lg:mb-0 xl:pr-32 text-3xl sm:text-5xl lg:leading-tight lg:my-reset"
          >
            {title}
          </Paragraph>
        ) : null}
        <div className="col-span-2 text-right">
          <Button
            {...{
              onClick: () => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              },
              className: 'hidden lg:inline-grid',
              label: 'Free Sign Up',
              rounded: true,
              target: 'blank',
              variant: 'secondary',
              size: 'large',
            }}
          />
        </div>
        <div className="grid col-span-4">
          <p className="mb-3.5 lg:mb-4 text-2xl">{subtitle}</p>
          <ul className="flex flex-wrap flex-col lg:flex-row items-center mb-12 lg:mb-0 lg:mt-4 lg:gap-x-16 gap-y-5 lg:mb-0">
            {dateTimes.map(({ dateTime }, index) => {
              return (
                <li
                  key={index}
                  className="col-span-1 flex items-center lg:w-52"
                >
                  <Image
                    src="/calendar.svg"
                    alt=""
                    className="mr-2"
                    loading="lazy"
                    width={20}
                    height={20}
                  />
                  <p className="flex items-center text-base">{dateTime}</p>
                </li>
              );
            })}
          </ul>
          <Button
            {...{
              onClick: () => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              },
              className: 'lg:hidden',
              label: 'Free Sign Up',
              rounded: true,
              target: 'blank',
              variant: 'secondary',
              size: 'large',
            }}
          />
        </div>
      </section>
    </Wrap>
  );
};

export default DateTimes;
